<template>
  <div class="course-list page-graphic-list">
    <van-tabs v-model="active" swipeable animated sticky @change="tabChangeHandler">
      <van-tab v-for="item in tabList" :key="item.id" :title="item.className">
        <GraphicListItem :tab-detail="item" :key="item.id" :active="active" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { encyclopediaEntryType } from '@/services';
import GraphicListItem from './components/GraphicListItem.vue';

export default {
  components: {
    GraphicListItem
  },

  data() {
    return {
      parentId: '',
      active: 0,
      tabList: []
    };
  },
  mounted() {
    const { parentId, active } = this.$route.query;
    this.parentId = parentId;
    this.getTabList({ parentId });
    if (active) {
      this.active = parseInt(active, 10);
    }
  },
  methods: {
    async getTabList() {
      const { dataList } = await encyclopediaEntryType({ parentId: this.parentId });
      this.tabList = dataList;
    },

    tabChangeHandler() {
      //
    }
  }
};
</script>

<style lang="less">
.course-list.page-graphic-list {
  /* 与顶部站点导航留出空隙 */
  padding-top: 12px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding-top: 20px;
  }

  .van-tabs {
    display: flex;
    flex-direction: column;
  }
  .van-tabs__wrap {
    height: 48px;
  }
  .van-tabs__content {
    background-color: #f5f5f5;
    padding-top: 12px;
  }
  .list {
    .van-cell {
      padding: 16px;
    }
  }
  .list-item-card {
    .left img {
      width: 90px;
      height: 60px;
    }
  }

  @media (min-width: 768px) {
    .van-tabs__wrap {
      height: 52px;
      padding: 0 16px;
      box-sizing: border-box;
    }

    .van-tabs__nav {
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      padding: 4px 8px;
    }

    .van-tab {
      font-size: 15px;
      line-height: 44px;
    }

    .van-tabs__line {
      bottom: 8px;
    }

    .van-tabs__content {
      padding: 20px 24px 32px;
    }

    .graphic-list-item .list {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
      align-content: start;

      .van-cell {
        padding: 18px 20px;
        margin: 0;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
      }

      .van-cell::after {
        display: none;
      }
    }

    .list-item-card {
      .left img {
        width: 120px;
        height: 80px;
        border-radius: 6px;
      }
      .right .title {
        font-size: 16px;
        line-height: 22px;
      }
      .desc span {
        font-size: 13px;
      }
    }
  }

  @media (min-width: 1100px) {
    .graphic-list-item .list {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 20px;
    }
  }
}
</style>
